import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';


@Component({
  standalone: false,
  selector: 'app-access-error',
  templateUrl: './access-error.component.html',
  styleUrls: ['./access-error.component.scss']
})
export class AccessErrorComponent implements OnInit {
  public errorMessage: string;
  public errorMessageHeader: string;
  public translations: any;
  tryAgain: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    ) {}

  ngOnInit() {
    this.getTranslations();
    this.getErrorMessage();
  }

  public getErrorMessage() {
    const error = this.route.snapshot.paramMap.get('error');

    if (this.translations != undefined) {
      switch (error) {
        case '403':
          this.errorMessageHeader = this.translations['Access.AccessForbidden'];
          this.errorMessage = this.translations['Access.AdministratorContact'];
          this.tryAgain = this.translations['Common.TryAgain'];
          break;
        case '504':
          this.errorMessageHeader = this.translations['Access.AccessGateway'];
          this.errorMessage = this.translations['Access.AdministratorContact'];
          this.tryAgain = this.translations['Common.TryAgain'];
          break;
        /* istanbul ignore next */
        default:
          this.errorMessageHeader = this.translations['Access.UnknownError'];
          this.errorMessage = this.translations['Access.AdministratorContact'];
          this.tryAgain = this.translations['Common.TryAgain'];
          break;
      }
    } else {
      this.tryAgain = 'Try Again';
      this.errorMessageHeader = 'Unknown Error';
      this.errorMessage = 'Please contact your administrator';
    }
  }

  public redirectToLogin() {
    this.router.navigateByUrl('home');
  }

  /**
   */
  public async getTranslations() {
    const translations = await firstValueFrom(this.translateService.get([
      'Access.AccessForbidden',
      'Access.AdministratorContact',
      'Access.UnknownError',
      'Access.AccessGateway',
      'Common.TryAgain'
    ]));

    this.translations = translations;
  }
}
